module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1245-min.8c788bb4.jpg";